var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.itemsTipoLead,"loading":_vm.loading,"label":_vm.label,"rules":_vm.rules},model:{value:(_vm.tipoLead),callback:function ($$v) {_vm.tipoLead=$$v},expression:"tipoLead"}})}
var staticRenderFns = []

export { render, staticRenderFns }